import { Navigate, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useTenant } from "../context/tenantContext";
import { MenuLateral } from "../pages/lateralMenu";

export const ProtectedLayout = () => {
  const { selectedTenant, isLoading, hasMultipleTenants } = useTenant();

  // // Se estiver carregando, mostra loading
  // if (isLoading) {
  //   return (
  //     <div className="flex h-screen justify-center items-center">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-quaternary mx-auto"></div>
  //         <p className="mt-4 text-gray-600">Carregando...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // Se tiver múltiplos tenants e nenhum selecionado, redireciona
  if (hasMultipleTenants && !selectedTenant) {
    return <Navigate to="/tenant-selection" replace />;
  }

  return (
    <div className="flex h-screen">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
      />
      <MenuLateral />
      <div className="w-full h-full fixed z-10 pl-[60px]">
        <div className="w-full h-full flex justify-center">
          <div className="w-full max-w-[1500px] px-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
